export default __webpack_public_path__ + "static/media/tele3.c9782c8a.svg";